import type { PropsWithChildren } from 'react'

import { useCallback, useEffect, useRef } from 'react'
import textfit from 'textfit'

import { cn } from '@/utils'

type Props = PropsWithChildren & {
  height?: string
  className?: string
  multiLine?: boolean
}

export function RundownOutputTextFitWrapper({
  height = '1vh',
  className = '',
  multiLine = false,
  children,
}: Props) {
  const visibleElementRef = useRef<HTMLDivElement>(null)
  const hiddenElementRef = useRef<HTMLDivElement>(null)

  const fit = useCallback(() => {
    // Fit elapsed time
    const elapsedEl = hiddenElementRef.current
    if (elapsedEl) {
      elapsedEl.innerHTML = visibleElementRef.current.innerHTML
      textfit(elapsedEl, { maxFontSize: 999, multiLine, detectMultiLine: true })
      visibleElementRef.current.style.fontSize =
        elapsedEl.querySelector('span.textFitted')?.style.fontSize
    }
  }, [multiLine])

  useEffect(() => {
    fit()
    window.addEventListener('resize', fit)

    return () => document.removeEventListener('resize', fit)
  }, [children, fit])

  return (
    <div
      className={cn(
        'relative flex flex-col items-center justify-center text-center leading-none',
        className,
      )}
      style={{ height }}
    >
      <div
        ref={hiddenElementRef}
        className="w-full flex items-center justify-center opacity-0"
        style={{ height }}
      >
        {/* Holding DIV needed incase the children disappear */}
        <div>{children}</div>
      </div>
      <div
        ref={visibleElementRef}
        className="w-full flex items-center justify-center absolute top-0 bottom-0"
        style={{ height }}
      >
        {/* Holding DIV needed incase the children disappear */}
        <div>{children}</div>
      </div>
    </div>
  )
}
